module.exports = __webpack_public_path__ + "images/favicon-16x16.847cb9444691f65917a9744427523d0d.png";


//////////////////
// WEBPACK FOOTER
// ../src/client/assets/images/favicons/favicon-16x16.png
// module id = 998
// module chunks = 0